var _defs, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreyStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_6362",
    "data-name": "Groupe 6362",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36.777,
    height: 36.777,
    viewBox: "0 0 36.777 36.777",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_100",
    "data-name": "Rectangle 100",
    width: 25.474,
    height: 25.348,
    fill: "none"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_99",
    "data-name": "Rectangle 99",
    width: 36.777,
    height: 36.777,
    rx: 7,
    transform: "translate(0)",
    fill: "#c4c4c4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_120",
    "data-name": "Groupe 120",
    transform: "translate(5.743 5.714)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_119",
    "data-name": "Groupe 119",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_542",
    "data-name": "Trac\\xE9 542",
    d: "M61.469,57.09l1.9,3.854,4.253.618a1.827,1.827,0,0,1,1.013,3.117l-3.077,3,.727,4.236a1.827,1.827,0,0,1-2.651,1.926l-3.8-2-3.8,2a1.827,1.827,0,0,1-2.651-1.926l.727-4.236-3.077-3a1.827,1.827,0,0,1,1.013-3.117l4.253-.618,1.9-3.854a1.827,1.827,0,0,1,3.277,0Z",
    transform: "translate(-47.156 -52.388)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyStar);
export default __webpack_public_path__ + "static/media/grey-star.4e4309903fd8384c2e0b744e0877043b.svg";
export { ForwardRef as ReactComponent };